/** Преобразовать количество байтов к ближайшему целому значению единицы более высокого порядка
 * @param {number} bytes Количество байтов
 * @returns {string}
 *  */
export const bytesToSize = (bytes: number) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
  return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
};
